// Google Ads / GA4 tracking helpers.
// The gtag base tag is loaded from public/index.html (AW-18382280523).
// This module provides safe wrappers to fire semantic events and
// (optionally) map them to Google Ads conversions via a label env var.

const CONVERSION_ID = "AW-18382280523";
// Optional label produced by Google Ads → Conversions → +New → Website.
// If empty, we still fire a semantic `whatsapp_click` event that shows up in
// GA4 / Google Ads Enhanced Conversions.
const WHATSAPP_LABEL = process.env.REACT_APP_GADS_WA_LABEL || "";

function safeGtag(...args) {
  if (typeof window === "undefined") return;
  const g = window.gtag;
  if (typeof g !== "function") return;
  try { g(...args); } catch (_) { /* noop */ }
}

/**
 * Reports a WhatsApp CTA click.
 * @param {string} source — where the click happened (nav, hero, contact, floating, share, booking, mobile-nav).
 */
export function trackWhatsAppClick(source = "unknown") {
  // 1) Semantic event — always fires (useful for GA4, Ads Enhanced Conversions,
  //    and custom audiences based on engagement)
  safeGtag("event", "whatsapp_click", {
    event_category: "engagement",
    event_label: source,
    source,
  });

  // 2) Google Ads conversion — only fires if the label has been provisioned
  //    in the Ads dashboard and injected via REACT_APP_GADS_WA_LABEL.
  if (WHATSAPP_LABEL) {
    safeGtag("event", "conversion", {
      send_to: `${CONVERSION_ID}/${WHATSAPP_LABEL}`,
      value: 1.0,
      currency: "BRL",
      event_category: "whatsapp",
      event_label: source,
    });
  }
}
